import { StatusDropdown } from "components";
import React from "react";
import BaseModal from "./BaseModal";
import { useBatchChangeStatus } from "show/list/hooks/apis";

interface Props {
  statuses: server.dto.StatusSmall[]
  mainArea: server.dto.MainAreas
  clientId: number
  onClose: () => void
}

const ChangeStatusModal = (props: Props) => {
  const [selectedStatus, setSelectedStatus] = React.useState<server.dto.StatusSmall>();

  const statusMutation = useBatchChangeStatus(props.mainArea);

  const applyChanges = async () => statusMutation.mutateAsync(selectedStatus.statusId);
  return <BaseModal
    mainArea={props.mainArea}
    action="change"
    onClose={props.onClose}
    title={RESX.Status.ChangeStatus}
    hasSelectedValue={selectedStatus != null}
    api={applyChanges}
  >
    <StatusDropdown
      options={props.statuses}
      value={selectedStatus}
      onChange={setSelectedStatus}
      mainArea={props.mainArea}
      clientId={props.clientId}
    />
  </BaseModal>;
};

export default ChangeStatusModal;